import { render, staticRenderFns } from "./AddCost.vue?vue&type=template&id=a6ceaf02&scoped=true"
import script from "./AddCost.vue?vue&type=script&lang=js"
export * from "./AddCost.vue?vue&type=script&lang=js"
import style0 from "./AddCost.vue?vue&type=style&index=0&id=a6ceaf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ceaf02",
  null
  
)

export default component.exports